import React, {useState, useEffect, useRef} from 'react';
import { Table } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';

import SPTableActionBar from '../table-action-bar';

import { useCarModelPrice } from 'hooks/product-price/car-model-price';
import CarProdName from "./car-prod-name";
import EnumKeyToText from "../../base/EnumKeyToText";
import DepositItem from "./deposit-item";
import InsuranceItem from "./insurance-item";
import CarTypeItem from "./car-type-item";
import SaleRuleItem from "./sale-rule-item";
import {DEFAULT_PAGE_INFO} from "../../../../consts";
import CarRelatVeh from "./car-relate-veh";
import CarTagsItem from "./car-tags-item";
import {encryptTextByAES} from "../../../../utils/encryption";
import emiter, {_EVENTS} from "../../../../events";

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface ICarModelPriceTableDataType {
    key?: any;
    id?: any;
    name?: any;
    state?: any;
    createDate?: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  const columns: TableProps<ICarModelPriceTableDataType>['columns'] = [
    // { title: '供应商名称', dataIndex: 'supplier_name', key: 'supplier_name' },
    { title: '门店', width: 120, dataIndex: 'store_name', key: 'store_name' },
    { title: '车型名称', width: 220, dataIndex: 'packageName', render: (_, record) => (<CarProdName data={record} />) },
    { title: '牌照', width: 80, dataIndex: 'veh_num_type', render: (_, record) => (<EnumKeyToText data={record} enums={enums} valueKey={'veh_num_type'} nameSpace={'veh_num_type'} />)  },
    { title: '关联车辆', width: 160, dataIndex: 'packageName', render: (_, record) => (<CarRelatVeh data={record} />)  },
    { title: '押金', width: 150, dataIndex: 'packageName', render: (_, record) => (<DepositItem data={record} />) },
    { title: '车型价格', width: 150, dataIndex: 'packageName', render: (_, record) => (<CarTypeItem data={record} />) },
    { title: '销售规则状态', width: 120, dataIndex: 'sale_status', render: (_, record) => (<EnumKeyToText data={record} enums={enums} valueKey={'sale_status'} nameSpace={'sale_status_finished'} />)  },
    { title: '车型标签', width: 120, dataIndex: 'tags', render: (_, record) => (<CarTagsItem enums={enums} data={record} />)  },
    { title: '增值服务', width: 200, dataIndex: 'packageName', render: (_, record) => (<InsuranceItem data={record} />) },
    { title: '销售规则', width: 150, dataIndex: 'packageName', render: (_, record) => (<SaleRuleItem data={record} />) },
    { title: '操作', width: 160, fixed: 'right', key: 'action', render: (_, record) => (<SPTableActionBar permission={permission} data={record} />) },
  ];

  const [data, setData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>();
  const dataRef = useRef({});

  const { search, onSearchAction, tablePagination } = useCarModelPrice();

  const load = (params?: any) => {
    const queryParams = Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params)
    params = {...queryParams}
    params.veh_num = params && params.veh_num
        ? encryptTextByAES(params.veh_num)
        : ''
      search(params).then((data: any) => {
        const res = data?.data
        setData(res?.list || []);
        setTotalCount(res?.total);
        dataRef.current = {...queryParams}
        setCurrentPageData({page: res.page || 1, page_size: res.page_size || 10});
    })
  };

  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(Object.assign(dataRef.current, {
        page: pagination.current,
        page_size: pagination.pageSize
    }))
  };

  useEffect(() => {
    emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, load);
    return () => {
      emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH)
    }
  }, []);

  return <Table
    size='middle'
    scroll={{ x: '100%' }}
    columns={columns}
    dataSource={data}
    rowKey={cols => cols.id}
    pagination={{ total:totalCount, showSizeChanger: true, showQuickJumper: true,showTotal:total => `共 ${total} 条数据`,current:currentPageData?.page, pageSize:currentPageData?.page_size }}
    onChange={onPagination}
  />
};

export default SPTable;
